import React, { useEffect, useState } from "react";
import { resolveMediaUrl, handleMediaImgError } from "../Helper/mediaUrl";
import { fetchCommunityReactionTypes } from "./communitySocialApi";

/**
 * Like reaction picker — loads Reaction Types from Admin canonical configuration.
 * No hardcoded type names or icons.
 */
function ReactionTypeDialog({
  open = false,
  onClose = null,
  onSelect = null,
  activeTypeId = null,
  hasActiveReaction = false,
  busy = false,
}) {
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    let cancelled = false;
    setLoading(true);
    setError("");
    fetchCommunityReactionTypes().then((res) => {
      if (cancelled) return;
      setLoading(false);
      if (res.error) {
        setError(res.message || "Unable to load Reaction Types");
        setTypes([]);
        return;
      }
      setTypes(Array.isArray(res.reaction_types) ? res.reaction_types : []);
    });
    return () => {
      cancelled = true;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="community-prayer-dialog community-reaction-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="community-reaction-dialog-title"
    >
      <div className="community-prayer-dialog__backdrop" onClick={onClose} />
      <div className="community-prayer-dialog__panel">
        <header className="community-prayer-dialog__head">
          <h3 id="community-reaction-dialog-title">React</h3>
          <button
            type="button"
            className="community-prayer-dialog__close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </header>
        {loading ? (
          <p className="community-create-post__hint">Loading Reaction Types…</p>
        ) : null}
        {error ? (
          <p className="community-create-post__error" role="alert">
            {error}
          </p>
        ) : null}
        {!loading && !error && !types.length ? (
          <p className="community-create-post__hint">
            No Reaction Types are configured yet. Ask an administrator to add them.
          </p>
        ) : null}
        <ul className="community-prayer-dialog__list community-reaction-dialog__list">
          {types.map((type) => {
            const active =
              activeTypeId != null && Number(activeTypeId) === Number(type.id);
            const img = type.image || type.image_path;
            return (
              <li key={type.id}>
                <button
                  type="button"
                  className={
                    "community-prayer-dialog__option" + (active ? " is-active" : "")
                  }
                  disabled={busy}
                  onClick={() => {
                    if (typeof onSelect === "function") onSelect(type);
                  }}
                >
                  {img ? (
                    <img
                      src={resolveMediaUrl(img)}
                      alt=""
                      onError={handleMediaImgError}
                    />
                  ) : type.emoji ? (
                    <span className="community-prayer-dialog__icon" aria-hidden="true">
                      {type.emoji}
                    </span>
                  ) : (
                    <span className="community-prayer-dialog__icon" aria-hidden="true">
                      👍
                    </span>
                  )}
                  <span>{type.name}</span>
                </button>
              </li>
            );
          })}
        </ul>
        {activeTypeId || hasActiveReaction ? (
          <button
            type="button"
            className="community-prayer-dialog__clear"
            disabled={busy}
            onClick={() => {
              if (typeof onSelect === "function") onSelect(null);
            }}
          >
            Remove Reaction
          </button>
        ) : null}
      </div>
    </div>
  );
}

export default ReactionTypeDialog;
